import React from 'react'
import { withRouter } from 'react-router-dom'
import { Spin } from 'antd'
import { connect } from 'react-redux'

const mapStateToProps = ({ customSpinner }) => ({
  apiloading: customSpinner.apiloading
})

@withRouter
@connect(mapStateToProps)
class PublicLayout extends React.PureComponent {
  render() {
    const {
      children,
      apiloading,
    } = this.props
    return (
      <Spin spinning={apiloading} tip="Loading...">
        {children}
      </Spin>
    )
  }
}

export default PublicLayout
